import React from "react";

import RandingStyle27 from "../../randing/RandingStyle27";

function Randing486({ urlCode, urlCodeSettingId }) {
  const imageAltTexts = {
    step1:
      "지르코니아 + 맞춤 지대주 포함 안산에서 최저가! 국산정품 임플란트 49만원 설문 참여하고 혜택 받으세요! 진행상황 0% 임플란트가 필요한 부위는 어디인가요?",
    step2:
      "지르코니아 + 맞춤 지대주 포함 안산에서 최저가! 국산정품 임플란트 49만원 설문 참여하고 혜택 받으세요! 진행상황 50% 성함과 연락처를 입력해주세요",
    step3:
      "지르코니아 + 맞춤 지대주 포함 안산에서 최저가! 국산정품 임플란트 49만원 설문 참여하고 혜택 받으세요! 마지막 확인입니다 동의 시 전문 상담원이 전화로 무료상담을 진행할 예정입니다",
  };

  const stepImages = {
    step1: `${process.env.REACT_APP_CDN_BASE}/images/486/01.png`,
    step2: `${process.env.REACT_APP_CDN_BASE}/images/486/02(1).png`,
    step3: `${process.env.REACT_APP_CDN_BASE}/images/486/03.png`,
  };

  const selectOptions = ["앞니", "어금니", "전체", "모르겠음"];

  return (
    <>
      <style>{`
        @media (min-width: 769px) {
          .randing-style-27 .step2 .step-content {
            bottom: 9% !important;
          }
          .randing-style-27 .step3 .step-content {
            bottom: 9% !important;
          }
        }
      `}</style>
      <RandingStyle27
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        imageFolderPath={`${process.env.REACT_APP_CDN_BASE}/images/486`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/144/bluegif.gif`}
        companyName="본원"
        imageExtension="png"
        imageAltTexts={imageAltTexts}
        stepImages={stepImages}
        selectOptions={selectOptions}
        legacyMarketing={true}
      />
    </>
  );
}

export default Randing486;
